import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

import { Group }             from '../../../../../../models/program/group';
import { Wave }             from '../../../../../../models/program/wave';

interface MenuEvent {
  group: Group;
  item: string;
}

interface CheckEvent {
  group: Group;
  checked: boolean;
}

@Component({
  selector: 'app-group-table',
  templateUrl: './group-table.component.html',
  styleUrls: ['./group-table.component.less']
})

export class GroupTableComponent implements OnInit {
  @Input() groups: Group[];
  @Input() groupArray: Array<any>;
  @Input() showHeader = false;
  @Input() showEmpty = true;
  @Input() wave: Wave = null;
  @Input() loneWave: boolean;
  @Output() goToWave: EventEmitter<number> = new EventEmitter<number>();
  @Output() menuItemSelected: EventEmitter<MenuEvent> = new EventEmitter<MenuEvent>();
  @Output() checkGroupArray: EventEmitter<CheckEvent> = new EventEmitter<CheckEvent>();
  @Output() waveSettings: EventEmitter<Wave> = new EventEmitter<Wave>();
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/dashboard/program-list/program/groups/group/group-table/group-table.component.ts